<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col lg="6" cols="7">
          <h6 class="h2 text-white d-inline-block mb-0">{{ $route.name }}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb />
          </nav>
        </b-col>
      </b-row>
    </base-header>

    <b-container fluid class="container-fluid mt--6">
      <b-row class="justify-content-center">
        <b-col lg="8" class="card-wrapper ct-example">
          <b-card no-body>
            <b-card-header>
              <h3 class="mb-0">Grievances</h3>
            </b-card-header>
            <b-card-body>
              <b-col
                cols="12"
                class="
                  d-flex
                  justify-content-center justify-content-sm-between
                  flex-wrap
                "
              >
                <base-input>
                  <select
                    class="form-control"
                    v-model.number="page.page_size"
                    placeholder="Per page"
                    @change="getData"
                  >
                    <option value="3">3</option>
                    <option value="6">6</option>
                    <option value="9">9</option>
                    <option value="12">12</option>
                    <option value="30">30</option>
                  </select>
                </base-input>
                <!-- <el-select
                  class="select-primary pagination-select"
                  v-model="pagination.perPage"
                  placeholder="Per page"
                >
                  <el-option
                    class="select-primary"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                    :name="item"
                  >
                  </el-option>
                </el-select> -->

                <div>
                  <base-input
                    v-model="page.keyword"
                    prepend-icon="fas fa-search"
                    placeholder="Search..."
                    @change="getData"
                  >
                  </base-input>
                </div>
              </b-col>

              <b-col
                md="4"
                v-for="grievance in grievances"
                :key="grievance._id"
                class="d-inline-block"
              >
                <card>
                  <!-- Card body -->
                  <div class="">
                    <div
                      class="d-inline-flex clsUrgent"
                      v-if="grievance.severity == 'urgent'"
                    >
                      <b>{{ grievance.severity | UPPERCASE }}</b>
                    </div>
                    <div
                      class="d-inline-flex clsHigh"
                      v-if="grievance.severity == 'high'"
                    >
                      <b>{{ grievance.severity | UPPERCASE }}</b>
                    </div>
                    <div
                      class="d-inline-flex clsMedium"
                      v-if="grievance.severity == 'medium'"
                    >
                      <b>{{ grievance.severity | UPPERCASE }}</b>
                    </div>
                    <div
                      class="d-inline-flex clsLow"
                      v-if="grievance.severity == 'low'"
                    >
                      <b>{{ grievance.severity | UPPERCASE }}</b>
                    </div>
                    <div
                      v-for="region in grievance.target_region"
                      :key="region"
                      class="clsRegionShorts"
                    >
                      {{ region.charAt(0) | UPPERCASE }}
                    </div>
                  </div>
                  <b-card-text class="mt-1">{{
                    grievance.created_date | READDATE
                  }}</b-card-text>
                  <b-card-title title-tag="h3" class="mb-3">{{
                    grievance.subject
                  }}</b-card-title>

                  <!-- <b-card-text class="mb-4">{{ grievance.message }}</b-card-text> -->

                  <!-- <base-button
                    v-if="grievance.isAcknowledged"
                    type="primary"
                    @click="getGrievance(grievance.grievanceId)"
                    >Edit</base-button
                  > -->
                  <base-button
                    v-if="!grievance.isAcknowledged"
                    type="success"
                    @click="getGrievance(grievance.grievanceId)"
                    >Quick ACK</base-button
                  >
                  <router-link
                    :to="{
                      name: 'Grievance Details',
                      params: { id: grievance.grievanceId },
                    }"
                  >
                    <base-button type="primary">Open</base-button>
                  </router-link>
                </card>
              </b-col>
            </b-card-body>

            <div
              slot="footer"
              class="
                col-12
                d-flex
                justify-content-center justify-content-sm-between
                flex-wrap
              "
            >
              <!-- <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries

                <span v-if="selectedRows.length">
                  &nbsp; &nbsp; {{selectedRows.length}} rows selected
                </span>
              </p>

            </div> -->
              <base-pagination
                class="pagination-no-border"
                :value="parseInt(page.page_no)"
                :perPage="parseInt(page.page_size)"
                :total="parseInt(page.total)"
                :size="'5'"
                @change="paginationChanged($event)"
              >
              </base-pagination>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-modal
        id="modal1"
        ref="modal"
        title="Update Grievance"
        @show="resetModal"
        @hidden="resetModal"
        @ok="handleOk"
      >
        <form>
          <b-row class="form-group">
            <b-col md="6" class="mb-3">
              Submitted on :
              <h2 class="mb-0">{{ createdDate }}</h2>
              Submitted by :
              <h2 class="mb-0">{{ selectedGrievance.created_by }}</h2>
            </b-col>
            <b-col md="6" v-if="selectedGrievance.isAcknowledged">
              Acknowledged on :
              <h2 class="mb-0">{{ acknowledgeDate }}</h2>
              Acknowledged by :
              <h2 class="mb-0">{{ selectedGrievance.acknowledged_by }}</h2>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col md="6">
              Severity:
              <h2 class="mb-0">
                <b>{{ selectedGrievance.severity | UPPERCASE }}</b>
              </h2>
            </b-col>
            <b-col md="6">
              Targetted Regions:
              <h4
                v-for="region in selectedGrievance.target_region"
                :key="region"
                class="mb-0"
              >
                {{ region | UPPERCASE }}
              </h4>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col md="12">
              Subject:
              <h2 class="mb-0">{{ selectedGrievance.subject }}</h2>
            </b-col>
            <b-col md="12">
              Message:
              <h2 class="mb-0">{{ selectedGrievance.message }}</h2>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col md="12">
              <base-input label="Acknowledgement Comment">
                <textarea
                  class="form-control"
                  id="exampleFormControlTextarea1"
                  rows="2"
                  v-model="selectedGrievance.comments"
                ></textarea>
              </base-input>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col md="12" class="text-right">
              <base-button
                v-if="!selectedGrievance.isAcknowledged"
                icon
                type="success"
                @click="onUploadClick"
              >
                <span class="btn-inner--icon"
                  ><i class="ni ni-bag-17"></i
                ></span>
                <span class="btn-inner--text">Acknowledge</span>
              </base-button>
              <!-- <base-button v-else icon type="success" @click="onUploadClick">
                <span class="btn-inner--icon"
                  ><i class="ni ni-bag-17"></i
                ></span>
                <span class="btn-inner--text">Acknowledge</span>
              </base-button> -->
            </b-col>
          </b-row>
        </form>
      </b-modal>
    </b-container>
  </div>
</template>
<script>
import RouteBreadcrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import BaseHeader from "@/components/BaseHeader";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../Tables/PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import moment from "moment";
import { mapGetters } from "vuex";
import { API } from "../../services/api.service";

export default {
  data: function () {
    return {
      inputs: {
        title: "Informational Message",
        message: "Welcome to our new Portal 🎉",
        type: "info",
        isHtml: false,
        start_date: "2021-10-18T07:56:23.768Z",
        end_date: "2021-11-18T16:50:35.196Z",
        audience: "all",
      },
      checkboxes: {
        unchecked: false,
        checked: true,
        uncheckedDisabled: false,
        checkedDisabled: true,
      },
      page: {
        page_size: 12,
        page_no: 1,
        keyword: "",
        total: 0,
      },
      grievances: [],
      selectedRows: [],
      selectedGrievance: {},
    };
  },
  filters: {
    formattedDate(value) {
      return moment(value);
    },
    UPPERCASE(str) {
      var newStr = "";
      if (str)
        for (var i = 0; i < str.length; i++) {
          var thisCharCode = str[i].charCodeAt(0);
          if (
            (thisCharCode >= 97 && thisCharCode <= 122) ||
            (thisCharCode >= 224 && thisCharCode <= 255)
          ) {
            newStr += String.fromCharCode(thisCharCode - 32);
          } else {
            newStr += str[i];
          }
        }
      return newStr;
    },
    READDATE(str) {
      var newDate = "";
      if (str) {
        newDate = moment(str).format("DD MMM YYYY");
      }
      return newDate;
    },
  },
  created() {
    this.getData();
  },
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    BaseHeader,
    RouteBreadcrumb,
  },
  computed: {
    ...mapGetters("user", ["getToken"]),
    createdDate: {
      get() {
        return this.selectedGrievance.created_date
          ? moment(this.selectedGrievance.created_date).format("DD MMM YYYY")
          : "";
      },
      // setter
    },
    acknowledgeDate: {
      get() {
        return this.selectedGrievance.acknowledged_on
          ? moment(this.selectedGrievance.acknowledged_on).format("DD MMM YYYY")
          : "";
      },
    },
  },
  methods: {
    myToUpperCase(str) {
      var newStr = "";
      if (str)
        for (var i = 0; i < str.length; i++) {
          var thisCharCode = str[i].charCodeAt(0);
          if (
            (thisCharCode >= 97 && thisCharCode <= 122) ||
            (thisCharCode >= 224 && thisCharCode <= 255)
          ) {
            newStr += String.fromCharCode(thisCharCode - 32);
          } else {
            newStr += str[i];
          }
        }
      return newStr;
    },
    getGrievance(id) {
      API.GET_GRIEVANCE(id)
        .then((res) => {
          try {
            if (res.data.ok) {
              this.selectedGrievance = res.data.result;
              !this.selectedGrievance.comments
                ? (this.selectedGrievance.comments = "")
                : true;
              this.showModal();
            } else if (err) {
              throw err;
            }
          } catch (e) {}
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getData() {
      let params = {
        page_size: this.page.page_size,
        page_no: this.page.page_no,
        keyword: this.page.keyword ? this.page.keyword : "",
      };
      API.GET_ALL_GRIEVANCES({ params })
        .then((res) => {
          try {
            if (res.data.ok) {
              this.tableData = res.data.result.items;
              this.grievances = res.data.result.items;
              this.page = res.data.result.page;
            } else if (err) {
              throw err;
            }
          } catch (e) {}
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onUploadClick() {
      //   this.validate();
      try {
        // if (!this.errors.length) {
        let dataObj = {
          comments: this.selectedGrievance.comments,
        };

        API.ACK_GRIEVANCE(this.selectedGrievance.grievanceId, dataObj)
          .then(async (res) => {
            swal.fire({
              title: `Grievance Acknowledged Successfully!`,
              buttonsStyling: false,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
            });
          })
          .catch((e) => {
            swal.fire({
              title: `Something Went Wrong`,
              buttonsStyling: false,
              type: "error",
              confirmButtonClass: "btn btn-success btn-fill",
            });
          });
        // }
      } catch (e) {
        swal.fire({
          title: `${e}`,
          buttonsStyling: false,
          type: "error",
          confirmButtonClass: "btn btn-danger btn-fill",
        });
      }
    },
    showModal() {
      this.$bvModal.show("modal1");
    },
    hideModal() {
      this.$bvModal.hide("modal1");
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.nameState = valid;
      return valid;
    },
    resetModal() {
      this.name = "";
      this.nameState = null;
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return;
      }
      // Push the name to submitted names
      this.submittedNames.push(this.name);
      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide("modal1");
      });
    },
    filesChange(files) {
      this.inputs.file = files;
    },
    paginationChanged(page) {
      this.page.page_no = page;
      this.page.keyword = this.page.keyword;
      this.getData();
    },
    handleLike(index, row) {
      swal({
        title: `You liked ${row.name}`,
        buttonsStyling: false,
        type: "success",
        confirmButtonClass: "btn btn-success btn-fill",
      });
    },
    handleEdit(index, row) {
      swal({
        title: `You want to edit ${row.name}`,
        buttonsStyling: false,
        confirmButtonClass: "btn btn-info btn-fill",
      });
    },
    handleDelete(index, row) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteRow(row);
          swal({
            title: "Deleted!",
            text: `You deleted ${row.name}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false,
          });
        }
      });
    },
    deleteRow(row) {
      let indexToDelete = this.tableData.findIndex(
        (tableRow) => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
  },
};
</script>
<style scoped>
.clsRegionOuter {
  text-align: end;
}
.clsRegionShorts {
  background: #2dce89;
  color: white;
  border-radius: 33%;
  display: inline-flex;
  padding: 0 0 0 4px;
  width: 1.5rem;
  margin: 2px;
  text-align: center;
  height: 1.5rem;
  float: right;
}
.clsUrgent {
  background: #ce2d2d;
  color: white;
  border-radius: 1rem;
  padding: 0 1rem;
  display: inline-flex;
  text-align: center;
  height: 1.5rem;
}
.clsHigh {
  background: #ce522d;
  color: white;
  border-radius: 1rem;
  padding: 0 1rem;
  display: inline-flex;
  text-align: center;
  height: 1.5rem;
}
.clsMedium {
  background: #ce7f2d;
  color: white;
  border-radius: 1rem;
  padding: 0 1rem;
  display: inline-flex;
  text-align: center;
  height: 1.5rem;
}
.clsLow {
  background: #c7a426;
  color: white;
  border-radius: 1rem;
  padding: 0 1rem;
  display: inline-flex;
  text-align: center;
  height: 1.5rem;
}
</style>
